<div class="flex flex-col full-grow-no-shrink-no-basis">
  <div class="title m-t-40"><i class="far fa-comment-lines"></i>Comments</div>
  <div class="full-grow-no-shrink-no-basis">

    <particle-comment-box
      [disabled]="dynamicData?.card?.permissionLevel === 0"
      [contextPath]="dynamicData.card.id"
      [scope]="dynamicData.card.scopeInt"
      [sourceType]="'TM'"
      [title]="dynamicData?.card?.displayId"
      [messageType]="messageType"
      [conversationType]="conversationType"
      [taskManagerCardId]="dynamicData.card.id"
      [focusAddCommentBox$]="focusAddCommentBox$"
      [taskAssignments]="dynamicData?.card?.assignments"
      [boardId]="dynamicData?.board?.id"
      [bringIntoView]="true"
      [hasCommentPermission]="hasCommentPermission"
    ></particle-comment-box>
  </div>
</div>
